import { useSettings } from "~/store/settings";
import api from "../auth/api";
import { useAuth } from "~/store/auth";
import { initialiseThreatmetrics } from "../initialiseThreatMetrics";

export default async function setSessionData() {
	const store = useSettings();
	const auth = useAuth();
	const { countryISOCode } = useISOCode();
	const threatMetric = await initialiseThreatmetrics();

	if (!sessionStorage.getItem("sessionDataSet") && store.config?.devConfig.wmsRegionId) {
		setTimeout(async () => {
			const request = new XMLHttpRequest();
			request.open("GET", "https://info.betwayafrica.com/api/v2/Device?showResults=true");
			request.send();
			request.onload = function () {
				const res = JSON.parse(this.response);
				const sessionReq = {
					platformID: getPlatformId(),
					regionId: store.config?.devConfig.wmsRegionId,
					vendorAccountID: auth.profile?.id,
					dataFree: store.isDataFree,
					bannerTag: useCookie("BTAGCOOKIE").value,
					countryCode: countryISOCode.value,
					userAgent: navigator.userAgent,
					ipAddress: "",
					deviceBrowserName: res.DeviceBrowserName,
					deviceBrowserVersion: res.DeviceBrowserVersion,
					isMobile: res.IsMobile,
					queryParamString: "",
					sessionTrackingToken: threatMetric?.sessionTrackingToken,
					sessionMetaData: [
						{
							cookieName: "REFERRERBTAGCOOKIE",
							cookieValue: useCookie("REFERRERBTAGCOOKIE").value,
							cookieDomain: "",
						},
						{
							cookieName: "MT",
							cookieValue: useCookie("MT").value,
							cookieDomain: "",
						},
						{
							cookieName: "ST",
							cookieValue: useCookie("ST").value,
							cookieDomain: "",
						},
					],
					isTable: res.IsTablet,
					isSynapse: true,
				};

				api({
					url: "/Marketing/AddMarketingSession",
					type: "api",
					options: {
						method: "POST",
					},
					data: sessionReq,
				});
			};
		}, 500);
		sessionStorage.setItem("sessionDataSet", "true");
	}
}
